// @ts-nocheck
import React, { useState } from 'react';
import CompanyTypesList from './components/CompanyTypeList';
import ActionBar from '../../layout/ActionBar';
import EditCompanyType from './slideout/EditCompanyType';
import SlidingPane from 'react-sliding-pane';
import Button from '../../common/Button';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../../util/pageTitle';

function CompanyTypes() {
  const [pageTitle, setPageTitle] = usePageTitle(['Company types', 'Settings']);
  const { t } = useTranslation();
  const [reload, setReload] = useState<Date | undefined>();
  const [addCompanyTypeSlideoutOpen, setAddCompanyTypeSlideoutOpen] =
    useState(false);

  return (
    <>
      <ActionBar>
        <Button
          className="btn btn-primary"
          onClick={() => setAddCompanyTypeSlideoutOpen(true)}
          text={t('Add company type')}
          testId="add-company-type-button"
        />
      </ActionBar>

      <CompanyTypesList reload={reload} />

      <SlidingPane
        isOpen={addCompanyTypeSlideoutOpen}
        hideHeader={true}
        from="right"
        className="side-panel"
        onRequestClose={() => setAddCompanyTypeSlideoutOpen(false)}
      >
        <EditCompanyType
          done={(d) => {
            setReload(new Date());
            setAddCompanyTypeSlideoutOpen(false);
          }}
          cancel={() => setAddCompanyTypeSlideoutOpen(false)}
        />
      </SlidingPane>
    </>
  );
}

export default CompanyTypes;
